import { useCallback } from "react";

import { getStoredUtmParams, hasUtmParams } from "@/lib/hubspot";

type HubSpotTrackingParams = {
	email: string;
	path: string;
};

export const useHubSpotTracking = () => {
	const track = useCallback(({ email, path }: HubSpotTrackingParams) => {
		const _hsq = (window._hsq = window._hsq || []);
		const utm = getStoredUtmParams();

		// UTM がある場合のみコンタクトトラッキングを有効にし、流入経路を渡す
		const identifyPayload: Record<string, string> = { email };
		if (hasUtmParams(utm)) {
			Object.assign(identifyPayload, utm);
		}
		_hsq.push(["identify", identifyPayload]);
		_hsq.push(["setPath", path]);
		_hsq.push(["trackPageView"]);
	}, []);

	return { track };
};
